export default [

	{
		name1: 'Дейл Хорват',
		name2: 'Джеффри ДеМунн',
		text: `
			<div class="title">Кто такой</div>
			<div class="text">
				Один из самых гуманистичных персонажей «Ходячих мертвецов». Выживший из группы Рика Граймса, который в коллективе отвечал не только за мудрость, но и за совесть: «Мир, каким мы его знали, исчез, но сохранять человечность — наш выбор». О том, кем был Дейл до эпидемии, не особо известно. Зомби-апокалипсис он встретил пенсионером и вдовцом: у его жены был выкидыш, а затем она умерла от рака. Дейл стал первым ключевым героем, погибшим в сериале.
			</div>
			<div class="title">Сколько продержался </div>
			<div class="text">
				Чуть-чуть не дожил до финала второго сезона.
			</div>
			<div class="title">Как погиб</div>
			<div class="text">
				В группе Рика Граймса разгорелся характерный для сериала спор, проверяющий героев на моральный релятивизм: избавиться от опасного пленника или нет? Шейн Уолш призывал его казнить, Дейл — не трогать. Хорват решил обойти всех членов коллектива, чтобы напомнить о ценности жизни, в то время как маленький сын Рика — Карл — решил поиграть со смертью: подразнить застрявшего в трясине зомби. Зомби вырвался на свободу — и убил Дейла. Но труды Хорвата не оказались напрасными: Рик не казнил пленника. Хотя герой об этом так и не узнал.
			</div>
		`
	},

	{
		name1: 'Шейн Уолш',
		name2: 'Джон Бернтал',
		text: `
			<div class="title">Кто такой</div>
			<div class="text">
			Лучший друг Рика Граймса со школьной скамьи. До зомби-апокалипсиса они вместе служили в полиции и были напарниками. Шейн испытывал влечение к жене Рика — Лори, но до эпидемии своих чувств никак не показывал, а потом у них завязался роман. Но когда Лори узнала, что Рик жив, она отвергла Шейна, что привело к обострению отношений между старыми друзьями. Уолш невероятно брутальный персонаж, который не привык церемониться с людьми (на этой почве у него были постоянные конфликты с Дейлом Хорватом), но ему все же свойственны угрызения совести, потому что за неприкрытым мачизмом и радикальными взглядами героя скрывается сложная амбивалентная натура.
			</div>
			<div class="title">Сколько продержался </div>
			<div class="text">
			Шейн умер вслед за Дейлом Хорватом. Причем играющий его Джон Бернтал был в курсе того, что его персонаж не проживет дольше двух сезонов. Кстати, актер мог бы задержаться в сериале на куда более длительный срок, если бы изначально согласился на роль главного героя — Рика Граймса, — но он предпочел сыграть его друга.
			</div>
			<div class="title">Как погиб</div>
			<div class="text">
			Шейн захотел убить Рика и приготовил для него ловушку, но тот догадался о его намерениях — и опередил Уолша. После того как Шейн обратился в зомби, его метким выстрелом добил Карл, как бы расставив все акценты по поводу того, кто его настоящий отец.
			</div>
		`
	},

		{
			name1: 'Лори Граймс',
			name2: 'Сара Уэйн Каллис',
			text: `
				<div class="title">Кто такая</div>
				<div class="text">
				Жена Рика Граймса. Она довольно рано выскочила за него замуж, у них родился сын Карл. Со временем отношения супругов испортились, но их примирил апокалипсис. Лори всегда ставила интересы семьи выше интересов группы — и никогда этого не скрывала. Она была беременна, но до конца не была уверена, кто отец ее второго ребенка: Рик или Шейн? Когда Рик убил Шейна, в их отношениях снова наступила кризисная фаза, хотя Граймс все так же продолжал заботиться о ней.
				</div>
				<div class="title">Сколько продержалась </div>
				<div class="text">
				Лори погибла в начале третьего сезона.
				</div>
				<div class="title">Как погибла</div>
				<div class="text">
				В тюрьму, в которой скрывалась группа Рика, прорвались зомби. Лори, Карл и Мэгги Грин были вынуждены отбиваться, но тут у Лори начались схватки, а роды пошли не по плану. Понимая, что ребенка можно спасти только кесаревым сечением, женщина велела вспороть ей живот ножом Карла. Этот эпизод — одна из самых безысходных и будоражащих сцен сериала, символизирующая собой то, что в мире «Ходячих мертвецов» жизнь со смертью ходят только рука об руку. Рик не видел, как погибла его жена, но после она много раз являлась ему в галлюцинациях.
				</div>
			`
		},
		{
			name1: 'Мерл Диксон',
			name2: 'Майкл Рукер',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				Брат Дэрила. Рос в неблагополучной семье — и это наложило отпечаток на его характер. Бывший военный, наркоторговец, убежденный расист. В первом сезоне лишился руки, во втором появился только в видении Дэрила. В третьем был заявлен как подручный Губернатора — одного из главных антагонистов сериала. Но после переметнулся на сторону группы Рика. Привык делать за других грязную работу.
				</div>
				<div class="title">Сколько продержался </div>
				<div class="text">
			  Вплоть до финала третьего сезона.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Мерл отправляется убить Губернатора, но терпит неудачу. Тот откусывает ему два пальца на здоровой руке — и стреляет в грудь. Превратившегося в зомби Мерла находит Дэрил и наносит ему несколько ударов ножом, вложив в них всю боль и отчаяние. Как и многие другие герои сериала, Мерл был верующим, а создатели «Ходячих мертвецов», как известно, не чураются библейских мотивов: братоубийство — один из них.

				</div>
			`
		},
		{
			name1: 'Андреа',
			name2: 'Лори Холден',
			text: `
				<div class="title">Кто такая</div>
				<div class="text">
				Выжившая из группы Рика Граймса, в прошлом — юрист. После смерти сестры хотела покончить с собой, но Дейл Хорват ее остановил. Переспала с Шейном Уолшем, но это ничего не значило для них обоих. Во время бойни на ферме осталась одна и сбежала в лес, где ее спасла чернокожая девушка по имени Мишонн. Вместе они попали в Вудбери — город, подконтрольный Губернатору. В отличие от Мишонн, Андреа не захотела уезжать. У нее завязались романтические отношения с Губернатором, который к тому времени начал потихоньку сходить с ума. Она попыталась примирить его с Риком — безуспешно.
				</div>
				<div class="title">Сколько продержалась </div>
				<div class="text">
			  Погибла в заключительной серии третьего сезона.
				</div>
				<div class="title">Как погибла</div>
				<div class="text">
				После того как отношения Андреа и Губернатора окончательно дали трещину, он привязал девушку к пыточному креслу и велел своему помощнику Милтону Мамету убить ее. Но тот не смог этого сделать, после чего Губернатор нанес ему несколько смертельных ранений и запер с девушкой в одном помещении — в расчете на то, что, когда Милтон обратится в зомби, он съест ее заживо. Однако Мамет успел оставить рядом с Андреа кусачки, чтобы она попыталась освободиться (и тут сценаристы продемонстрировали мастер-класс по нагнетанию саспенса в духе Альфреда Хичкока). Правда, несмотря на все старания, девушке не удалось спастись: она была покусана Милтоном и умерла на руках у Мишонн.
				</div>
			`
		},
		{
			name1: 'Хершел Грин',
			name2: 'Скотт Уилсон',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				Ветеринар и владелец фермы, на которой группа выживших Рика Граймса укрылась во втором сезоне. Почти все члены его семьи погибли в результате зомби-апокалипсиса, на данный момент жива только старшая дочь — Мэгги. Сам он потерял ногу, а когда группа Рика в третьем сезоне укрылась в тюрьме, оказывал медицинскую помощь пострадавшим. Хершел был душой сериала — и одним из самых пожилых его героев.
				</div>
				<div class="title">Сколько продержался </div>
				<div class="text">
				До середины четвертого сезона. Хотя мог бы умереть еще раньше, но создатели сериала решили продлить ему жизнь.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Губернатор безжалостно обезглавил Хершела катаной Мишонн во время штурма тюрьмы, что еще раз подчеркнуло тот факт, что опаснее ходячих мертвецов в сериале могут быть только живые безумцы.
				</div>
			`
		},
		{
			name1: 'Губернатор',
			name2: 'Дэвид Моррисси',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				Губернатор (его настоящее имя Филип Блейк) — главный злодей третьего и четвертого сезонов. Он возглавлял колонию выживших в Вудбери. О его жизни до апокалипсиса ничего не известно, кроме того, что его жена погибла в автоаварии, а дочь превратилась в зомби. Умел расположить к себе людей, а также мастерски манипулировать ими. Словом, настоящий психопат. Воевал с группой Рика Граймса. После Вудбери возглавил другой лагерь выживших, который повел войной на Рика и его друзей.
				</div>
				<div class="title">Сколько продержался </div>
				<div class="text">
				До середины четвертого сезона.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Во время штурма тюрьмы Губернатора катаной пронзила Мишонн, а затем выстрелом добила Лилли — женщина, которая поверила, что она и ее дочь Меган ему небезразличны, но это оказалось не так. Символично, что жизнь предоставила Филипу Блейку второй шанс, но он, одержимый местью и жаждой власти, не воспользовался им.
				</div>
			`
		},
		{
			name1: 'Лиззи Самуэльс',
			name2: 'Брайтон Шарбино',
			text: `
				<div class="title">Кто такая</div>
				<div class="text">
				Девочка с серьезными психологическими отклонениями, входящая в группу Рика. Появилась в четвертом сезоне. Давала имена ходячим мертвецам, кормила их мышами и даже пыталась с ними разговаривать. Убила свою сестру Мику, чтобы та смогла «переродиться». Этим повергла в ужас Тайриза Уильямса и Кэрол Пелетье.
				</div>
				<div class="title">Сколько продержалась</div>
				<div class="text">
				Один сезон.
				</div>
				<div class="title">Как погибла</div>
				<div class="text">
				Была застрелена Кэрол Пелетье в одном из самых, пожалуй, шокирующих эпизодов за всю историю сериала.
				</div>
			`
		},
		{
			name1: 'Боб Стуки',
			name2: 'Лоренс Гиллиард-мл.',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				До эпидемии был военным медиком. В четвертом сезоне стал частью группы Рика, когда та заселилась в тюрьму. Злоупотреблял алкоголем и был влюблен в Сашу Уильямс, та отвечала ему взаимностью.
				</div>
				<div class="title">Сколько продержался</div>
				<div class="text">
				Погиб в первых сериях пятого сезона.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Каннибалы из группы Гарета съели его левую ногу — впрочем, к тому времени Боб уже был укушен ходячим в правое плечо. Умер на руках у Саши и друзей. В зомби ему не дал обратиться Тайриз.
				</div>
			`
		},
		{
			name1: 'Бет Грин',
			name2: 'Эмили Кинни',
			text: `
				<div class="title">Кто такая</div>
				<div class="text">
				Младшая дочь Хершела Грина, которая долгое время оставалась в тени своей старшей и более активной сестры Мэгги. Подумывала о самоубийстве. Свою стеснительность Бет окончательно изжила к третьему сезону. Поскольку девушка всегда хотела иметь детей, она с энтузиазмом взялась заботиться о маленькой дочери Лоры Граймс — Джудит. Рик ценил это и не поручал Бет опасную работу.
				</div>
				<div class="title">Сколько продержалась</div>
				<div class="text">
				До первой половины пятого сезона.
				</div>
				<div class="title">Как погибла</div>
				<div class="text">
				Бет была случайна сражена пулей офицера Доун во время обмена в госпитале, подконтрольном полицейским. Особенно остро ее смерть пережили Дэрил Диксон и Мэгги.
				</div>
			`
		},
		{
			name1: 'Тайриз Уильямс',
			name2: 'Чад Колман',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				До апокалипсиса играл в американский футбол, после эпидемии стал сражаться против зомби. В этом ему помогали большой молоток и младшая сестра Саша. Появился только в третьем сезоне, в первом и втором его роль разделили Дэрил и Ти-Дог (тоже безвременно погибший). Сначала Тайриз (говорящее имя которого с греческого переводится как «бык») примкнул к армии Губернатора, но затем влился в группу Рика.
				</div>
				<div class="title">Сколько продержался</div>
				<div class="text">
				До середины пятого сезона.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Его укусил зомби, после чего Мишонн и другие поспешили ампутировать ему зараженную руку и доставить в безопасное место, но Тайриз не выдержал поездки и умер от потери крови. Перед смертью ему явились призраки прошлого — Губернатор, Бет Грин, Боб Стуки, Мартин, Лиззи и Мика Самуэльс, с некоторыми из которых у него завязывался спор. В этом полемическом запале и прошли последние минуты его жизни.
				</div>
			`
		},
		{
			name1: 'Абрахам Форд',
			name2: 'Майкл Кадлиц',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				Здоровый, но добродушный малый. Бывший военный, который потерял семью (жену и двоих детей) во время апокалипсиса. Впервые появился в четвертом сезоне. Спас Юджина Портера — ученого, который якобы знал, как остановить вирус (но на самом деле нет). По дороге в Вашингтон Абрахам встретил Розиту Эспинозу, с которой у него завязался роман. Вместе они вошли в группу Рика. Помимо этого, у Абрахама были любовные отношения с Сашей Уильямс.
				</div>
				<div class="title">Сколько продержался</div>
				<div class="text">
				До начала седьмого сезона.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Когда группа Рика отправилась за медицинской помощью для Мэгги Грин, она была остановлена Ниганом и его бандой Спасителей (главными антагонистами шестого и седьмого сезонов). Ниган велел подчиниться ему, а чтобы показать, что его намерения серьезны, избил Абрахама до смерти бейсбольной битой, обмотанной колючей проволокой.
				</div>
			`
		},
		{
			name1: 'Гленн Ри',
			name2: 'Стивен Ен',
			text: `
				<div class="title">Кто такой</div>
				<div class="text">
				Один из старейших героев сериала, появился в самой первой серии «Ходячих мертвецов». Отпрыск корейских эмигрантов и специалист по вылазкам в группе Рика (и один из самых близких его друзей). Женился на Мэгги Грин, с которой буквально прошел все круги ада.
				</div>
				<div class="title">Сколько продержался</div>
				<div class="text">
				До начала седьмого сезона.
				</div>
				<div class="title">Как погиб</div>
				<div class="text">
				Был абсолютно внезапно и совершенно безжалостно избит Ниганом вслед за Абрахамом Фордом. Его смерть стала апофеозом шок-драматургии поздних сезонов «Ходячих мертвецов».
				</div>
			`
		},
		{
			name1: 'Саша Уильямс',
			name2: 'Соника Мартин-Грин',
			text: `
				<div class="title">Кто такая</div>
				<div class="text">
				Младшая сестра Тайриза Уильямса. До апокалипсиса работала в пожарной бригаде, после вместе с братом жила в Вудбери, а затем присоединилась к группе Рика. Пережила многих друзей и близких, пожертвовала собой в войне Рика против Нигана.
				</div>
				<div class="title">Сколько продержалась</div>
				<div class="text">
				Погибла в финале седьмого сезона.
				</div>
				<div class="title">Как погибла</div>
				<div class="text">
				Была захвачена в плен Ниганом, но, не желая быть его игрушкой, приняла пилюлю с ядом, которую ей дал Юджин Портер. Превратилась в зомби — и тем самым расстроила планы Нигана. В обличье ходячего была убита Мэгги Грин-Ри.
				</div>
			`
		},
]



// WEBPACK FOOTER //
// ./src/data/slider3.js